"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMAIL_SEND_STATUS = exports.EMAIL_SEND_TYPE = void 0;
exports.EMAIL_SEND_TYPE = {
    INVITATION: 'invitation',
    NOTIFICATION_ROLE_UPDATED: 'notification_role_updated',
    NOTIFICATION_CONTACT_METHOD_UPDATED: 'notification_contact_method_updated',
    NOTIFICATION_WORK_ORDER_BID_PUBLISHED: 'notification_work_order_bid_published',
    NOTIFICATION_WORK_ORDER_CREATED: 'notification_work_order_created',
    NOTIFICATION_WORK_ORDER_UPDATED: 'notification_work_order_updated',
    NOTIFICATION_WORK_ORDER_ASSIGNED: 'notification_work_order_assigned',
    NOTIFICATION_WORK_ORDER_DELETED: 'notification_work_order_deleted',
    NOTIFICATION_WORK_ORDER_ATTACHMENT_CREATED: 'notification_work_order_attachment_created',
    NOTIFICATION_WORK_ORDER_ATTACHMENT_DELETED: 'notification_work_order_attachment_deleted',
    NOTIFICATION_WORK_ORDER_COMMENT_CREATED: 'notification_work_order_comment_created',
    NOTIFICATION_WORK_ORDER_WATCHER_CREATED: 'notification_work_order_watcher_created',
    NOTIFICATION_WORK_ORDER_WATCHER_DELETED: 'notification_work_order_watcher_deleted',
    NOTIFICATION_WORK_ORDER_UNASSIGNED: 'notification_work_order_unassigned',
    NOTIFICATION_WORK_ORDER_OVERDUE: 'notification_work_order_overdue',
    NOTIFICATION_NO_WORK_ORDER_CREATED: 'notification_no_work_order_created',
    NOTIFICATION_PROPERTY_CREATED: 'notification_property_created',
    NOTIFICATION_PROPERTY_UPDATED: 'notification_property_updated',
    NOTIFICATION_PROPERTY_DELETED: 'notification_property_deleted',
    NOTIFICATION_USER_ADDED_TO_PROPERTY: 'notification_user_added_to_property',
    NOTIFICATION_USER_REMOVED_FROM_PROPERTY: 'notification_user_removed_from_property',
    VERIFICATION: 'verification',
    CONCIERGE: 'concierge',
    USER_FEEDBACK: 'user_feedback',
    WEB_FORM_SUBMISSION_INTERNAL: 'web_form_submission_internal',
    WEB_FORM_SUBMISSION_VENDOR_EXTERNAL: 'web_form_submission_vendor_external',
    WEB_FORM_SUBMISSION_BID_REQUEST_EXTERNAL: 'web_form_submission_bid_request_external',
    WEB_FORM_SUBMISSION_SAFELEASE_APP_EXTERNAL: 'web_form_submission_safelease_app_external',
    WORK_ORDER_CREATED_INTERNAL: 'work_order_created_internal',
    TENANT_WORK_ORDER_SUBMISSION_EXTERNAL: 'tenant_work_order_submission_external',
    WARRANTY_PRODUCT_REQUEST_INTERNAL: 'warranty_product_request_internal',
};
exports.EMAIL_SEND_STATUS = {
    CREATED: 'created',
    PROCESSED: 'processed',
    DROPPED: 'dropped',
    DELIVERED: 'delivered',
    DEFERRED: 'deferred',
    BOUNCE: 'bounce',
    BLOCKED: 'blocked',
    FAILED: 'failed',
};
//# sourceMappingURL=email-send.types.js.map